import React from "react";
import { Login } from "../../features/Login";
import { Navbar, Nav, Container } from 'react-bootstrap';
import { Link } from 'react-router-dom';



export function PageLogin(): JSX.Element {
  return (
    <div className="position-fixed h-100 w-100 login-container-bg overflow-auto">
      <Login />
      {/* <Nav className="ml-auto">
        <Nav.Link as={Link} to="/media-diag">Media Diagnostics</Nav.Link>
      </Nav> */}
    </div>
  );
}
